import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'i18n-js';
import { ongoingDeliveriesV2Selector } from 'selectors/new-history-selectors';
import TrackGADuck from 'ducks/track-ga-duck';
import ScribeDuck from 'ducks/scribe-duck';
import ShopifyTrackEventContext from 'views/v2/shopify-home/track-event';
import OngoingBookingSection from './ongoing-booking-section';
import HistoryBookingSection from './history-booking-section';
import { useIntervalOngoingFetch } from './common-hooks';
import styles from './new-booking-table-page.less';

const NewBookingTablePage = () => {
  const dispatch = useDispatch();
  const { deliveries } = useSelector(ongoingDeliveriesV2Selector);
  const [loaded, setLoaded] = useState(Array.isArray(deliveries));

  useIntervalOngoingFetch('booking');

  useEffect(
    () => {
      if (!deliveries || loaded) return;
      setLoaded(true);
    },
    [deliveries],
  );
  useEffect(
    () => {
      if (!loaded) return;
      dispatch(
        TrackGADuck.creators.trackGAExpressBookingsWebPageView({
          ONGOING_BOOKINGS: deliveries.length,
        }),
      );
      dispatch(
        ScribeDuck.creators.scribeExpressBookingsWebOngoingSection(
          deliveries.length,
        ),
      );
    },
    [loaded],
  );

  const fireShopifyTrackEvent = ({ stateName, eventName, facets = {} }) => {
    dispatch(
      ScribeDuck.creators.scribeExpressBookingsWebShopify(
        stateName,
        eventName,
        facets,
      ),
    );
  };

  return (
    <ShopifyTrackEventContext.Provider value={{ fireShopifyTrackEvent }}>
      <div>
        <h4 className={styles.pageHeader}>{I18n.t('appSider.bookings')}</h4>
        <OngoingBookingSection />
        <HistoryBookingSection />
      </div>
    </ShopifyTrackEventContext.Provider>
  );
};

export default NewBookingTablePage;
